export const INVALID_DATE =
  'Please enter the date in MM/DD/YYYY format where year is 2 or 4 digits';
export const START_DATE_FUTURE_DATE = 'Start Date cannot be future date.';
export const START_DATE_GRETERTHAN_END_DATE =
  'End date cannot be less than Begin date.';

export const START_DATE_REQUIRED = 'Start Date is required.';
export const END_DATE_REQUIRED = 'End Date is required.';
export const PROCEDURE_TYPE_ERROR = 'Please Select the Procedure Type Value.';
export const NO_RESULT_FOUND_ERROR =
  'No results found for the search criteria selected';
